import type { LucideIcon } from "lucide-react";

interface OverviewEmptyStateProps {
  icon: LucideIcon;
  message: string;
}

export default function OverviewEmptyState({ icon: Icon, message }: OverviewEmptyStateProps) {
  return (
    <div className="overview-empty-state">
      <span className="overview-empty-icon" aria-hidden="true"><Icon /></span>
      <p>{message}</p>
    </div>
  );
}
